import { render, staticRenderFns } from "./patient-resume.vue?vue&type=template&id=59262c92&scoped=true&lang=pug&"
import script from "./patient-resume.vue?vue&type=script&lang=ts&"
export * from "./patient-resume.vue?vue&type=script&lang=ts&"
import style0 from "./patient-resume.vue?vue&type=style&index=0&id=59262c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59262c92",
  null
  
)

export default component.exports